
import Vue from 'vue'

const locales = {keys(){return []}}
global['________'] = true;
delete global['________'];
global.__uniConfig = {"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"体验舱大屏","navigationBarBackgroundColor":"#F8F8F8","backgroundColor":"#F8F8F8"}};
global.__uniConfig.compilerVersion = '3.98';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '';
global.__uniConfig.appName = '';
global.__uniConfig.appVersion = '1.0.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"hash","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {};
global.__uniConfig.qqMapKey = undefined;
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-home-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/xinghaidong/projects/aia/aia-dongya-hd/src/pages/home/index"+'.vue')), 'pages-home-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-face-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/xinghaidong/projects/aia/aia-dongya-hd/src/pages/face/index"+'.vue')), 'pages-face-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-face-photo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/xinghaidong/projects/aia/aia-dongya-hd/src/pages/face/photo"+'.vue')), 'pages-face-photo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-face-play', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/xinghaidong/projects/aia/aia-dongya-hd/src/pages/face/play"+'.vue')), 'pages-face-play'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-cms-home', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/xinghaidong/projects/aia/aia-dongya-hd/src/pages/cms/home"+'.vue')), 'pages-cms-home'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-cms-content', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/xinghaidong/projects/aia/aia-dongya-hd/src/pages/cms/content"+'.vue')), 'pages-cms-content'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-cms-detail-video', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/xinghaidong/projects/aia/aia-dongya-hd/src/pages/cms/detail-video"+'.vue')), 'pages-cms-detail-video'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-cms-detail-pdf', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/xinghaidong/projects/aia/aia-dongya-hd/src/pages/cms/detail-pdf"+'.vue')), 'pages-cms-detail-pdf'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-digi-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/xinghaidong/projects/aia/aia-dongya-hd/src/pages/digi/index"+'.vue')), 'pages-digi-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-digi-introduce', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/xinghaidong/projects/aia/aia-dongya-hd/src/pages/digi/introduce"+'.vue')), 'pages-digi-introduce'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-digi-details', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/xinghaidong/projects/aia/aia-dongya-hd/src/pages/digi/details"+'.vue')), 'pages-digi-details'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-digi-summary', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/xinghaidong/projects/aia/aia-dongya-hd/src/pages/digi/summary"+'.vue')), 'pages-digi-summary'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-recorder-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/xinghaidong/projects/aia/aia-dongya-hd/src/pages/recorder/index"+'.vue')), 'pages-recorder-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-recorder-record', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/xinghaidong/projects/aia/aia-dongya-hd/src/pages/recorder/record"+'.vue')), 'pages-recorder-record'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-recorder-end', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/xinghaidong/projects/aia/aia-dongya-hd/src/pages/recorder/end"+'.vue')), 'pages-recorder-end'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-chat-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/xinghaidong/projects/aia/aia-dongya-hd/src/pages/chat/index"+'.vue')), 'pages-chat-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-chat-talking', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/xinghaidong/projects/aia/aia-dongya-hd/src/pages/chat/talking"+'.vue')), 'pages-chat-talking'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/home/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,

          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"入口","navigationStyle":"custom"})
      },
      [
        createElement('pages-home-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-home-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/home/index',
isQuit:true,
isEntry:true,
  windowTop:0
}
},
{
path: '/pages/face/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"体验舱大屏","navigationStyle":"custom"})
      },
      [
        createElement('pages-face-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-face-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/face/index',
  windowTop:0
}
},
{
path: '/pages/face/photo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"体验舱大屏","navigationStyle":"custom"})
      },
      [
        createElement('pages-face-photo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-face-photo',
  isNVue:false,maxWidth:0,
  pagePath:'pages/face/photo',
  windowTop:0
}
},
{
path: '/pages/face/play',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"体验舱大屏","navigationStyle":"custom"})
      },
      [
        createElement('pages-face-play', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-face-play',
  isNVue:false,maxWidth:0,
  pagePath:'pages/face/play',
  windowTop:0
}
},
{
path: '/pages/cms/home',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"养老介绍","navigationStyle":"custom"})
      },
      [
        createElement('pages-cms-home', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-cms-home',
  isNVue:false,maxWidth:0,
  pagePath:'pages/cms/home',
  windowTop:0
}
},
{
path: '/pages/cms/content',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"养老内容","navigationStyle":"custom"})
      },
      [
        createElement('pages-cms-content', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-cms-content',
  isNVue:false,maxWidth:0,
  pagePath:'pages/cms/content',
  windowTop:0
}
},
{
path: '/pages/cms/detail-video',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"康养视频","navigationStyle":"custom"})
      },
      [
        createElement('pages-cms-detail-video', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-cms-detail-video',
  isNVue:false,maxWidth:0,
  pagePath:'pages/cms/detail-video',
  windowTop:0
}
},
{
path: '/pages/cms/detail-pdf',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"康养Pdf","navigationStyle":"custom"})
      },
      [
        createElement('pages-cms-detail-pdf', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-cms-detail-pdf',
  isNVue:false,maxWidth:0,
  pagePath:'pages/cms/detail-pdf',
  windowTop:0
}
},
{
path: '/pages/digi/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"数字人","navigationStyle":"custom"})
      },
      [
        createElement('pages-digi-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-digi-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/digi/index',
  windowTop:0
}
},
{
path: '/pages/digi/introduce',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"数字人","navigationStyle":"custom"})
      },
      [
        createElement('pages-digi-introduce', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-digi-introduce',
  isNVue:false,maxWidth:0,
  pagePath:'pages/digi/introduce',
  windowTop:0
}
},
{
path: '/pages/digi/details',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"数字人","navigationStyle":"custom"})
      },
      [
        createElement('pages-digi-details', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-digi-details',
  isNVue:false,maxWidth:0,
  pagePath:'pages/digi/details',
  windowTop:0
}
},
{
path: '/pages/digi/summary',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"数字人","navigationStyle":"custom"})
      },
      [
        createElement('pages-digi-summary', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-digi-summary',
  isNVue:false,maxWidth:0,
  pagePath:'pages/digi/summary',
  windowTop:0
}
},
{
path: '/pages/recorder/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"语音留言","navigationStyle":"custom"})
      },
      [
        createElement('pages-recorder-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-recorder-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/recorder/index',
  windowTop:0
}
},
{
path: '/pages/recorder/record',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"语音留言","navigationStyle":"custom"})
      },
      [
        createElement('pages-recorder-record', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-recorder-record',
  isNVue:false,maxWidth:0,
  pagePath:'pages/recorder/record',
  windowTop:0
}
},
{
path: '/pages/recorder/end',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"语音留言","navigationStyle":"custom"})
      },
      [
        createElement('pages-recorder-end', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-recorder-end',
  isNVue:false,maxWidth:0,
  pagePath:'pages/recorder/end',
  windowTop:0
}
},
{
path: '/pages/chat/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"智能问答","navigationStyle":"custom"})
      },
      [
        createElement('pages-chat-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-chat-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/chat/index',
  windowTop:0
}
},
{
path: '/pages/chat/talking',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"智能问答","navigationStyle":"custom"})
      },
      [
        createElement('pages-chat-talking', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-chat-talking',
  isNVue:false,maxWidth:0,
  pagePath:'pages/chat/talking',
  windowTop:0
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
